/**
 * Flattened employee import file status.
 */
export const EmployeeImportFileStatus = {
    VALIDATION_FAILED: 'validation_failed',
    WAITING_FOR_APPROVAL: 'waiting_for_approval',
    PROCESSING_FAILED: 'processing_failed',
    PROCESSING_SUCCESSFUL: 'processing_successful',
    IN_PROGRESS: 'in_progress',
}

/**
 * Get the flattened employee import file status.
 *
 * Statuses:
 * - validation_failed
 * - waiting_for_approval
 * - processing_failed
 * - processing_successful
 * - in_progress
 *
 * @param employeeImportFile
 * @return string
 */
export const getEmployeeImportFileStatus = (employeeImportFile) => {
    const {
        validation_completed_at,
        validation_errors,
        scp_user_approved_at,
        company_file,
    } = employeeImportFile

    if (validation_completed_at !== null && validation_errors?.length > 0) {
        return EmployeeImportFileStatus.VALIDATION_FAILED
    }

    if (validation_completed_at !== null
        && validation_errors?.length === 0
        && scp_user_approved_at === null
        && company_file === null
    ) {
        return EmployeeImportFileStatus.WAITING_FOR_APPROVAL
    }

    if (validation_completed_at !== null
        && validation_errors?.length === 0
        && scp_user_approved_at === null
        && company_file?.has_errors === true
    ) {
        return EmployeeImportFileStatus.PROCESSING_FAILED
    }

    if (validation_completed_at !== null
        && validation_errors?.length === 0
        && scp_user_approved_at !== null
        && company_file?.has_errors === false
        && company_file?.core_processed_at !== null
    ) {
        return EmployeeImportFileStatus.PROCESSING_SUCCESSFUL
    }

    return EmployeeImportFileStatus.IN_PROGRESS
}
